import { css } from "@linaria/core";

export const externalLinkIcon = css`
  height: 1.4rem;
  margin-top: -0.4rem;
  margin-left: 1rem;
`;
